function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  enableBackground: "new    "
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B51E3A",
  d: "M25.663,55.08h-7.193l-1.231-8.23H8.49l-1.231,8.23H0.713L7.971,9.717h10.434L25.663,55.08z M9.397,40.693 h6.869l-3.435-22.94L9.397,40.693z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  enableBackground: "new    "
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 0.4,
  d: "M25.663,55.08h-7.193l-1.231-8.23H8.49l-1.231,8.23H0.713L7.971,9.717 h10.434L25.663,55.08z M9.397,40.693h6.869l-3.435-22.94L9.397,40.693z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  enableBackground: "new    "
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B51E3A",
  d: "M44.518,55.08c-0.389-1.166-0.648-1.879-0.648-5.573v-7.128c0-4.213-1.426-5.768-4.666-5.768h-2.462V55.08 h-7.128V9.717h10.757c7.388,0,10.563,3.435,10.563,10.434v3.564c0,4.666-1.49,7.712-4.666,9.202 c3.564,1.49,4.731,4.925,4.731,9.656v6.998c0,2.204,0.065,3.824,0.778,5.509H44.518z M36.742,16.197v13.934h2.787 c2.657,0,4.277-1.167,4.277-4.796v-4.472c0-3.24-1.102-4.666-3.629-4.666H36.742z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  enableBackground: "new    "
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 0.4,
  d: "M44.518,55.08c-0.389-1.166-0.648-1.879-0.648-5.573v-7.128 c0-4.213-1.426-5.768-4.666-5.768h-2.462V55.08h-7.128V9.717h10.757c7.388,0,10.563,3.435,10.563,10.434v3.564 c0,4.666-1.49,7.712-4.666,9.202c3.564,1.49,4.731,4.925,4.731,9.656v6.998c0,2.204,0.065,3.824,0.778,5.509H44.518z  M36.742,16.197v13.934h2.787c2.657,0,4.277-1.167,4.277-4.796v-4.472c0-3.24-1.102-4.666-3.629-4.666H36.742z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  enableBackground: "new    "
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B51E3A",
  d: "M53.914,9.717h22.033v6.48h-7.453V55.08h-7.128V16.197h-7.452V9.717z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  enableBackground: "new    "
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 0.4,
  d: "M53.914,9.717h22.033v6.48h-7.453V55.08h-7.128V16.197h-7.452V9.717z"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  enableBackground: "new    "
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B0B0B1",
  d: "M79.703,9.717h7.128V55.08h-7.128V9.717z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B0B0B1",
  d: "M107.114,41.925l4.86-32.208h9.915V55.08h-6.74V22.549l-4.925,32.531h-6.74l-5.314-32.078V55.08h-6.221 V9.717h9.915L107.114,41.925z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B0B0B1",
  d: "M134.199,28.834h9.785v6.48h-9.785v13.285h12.313v6.48h-19.441V9.717h19.441v6.48h-12.313V28.834z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B0B0B1",
  d: "M150.916,9.717h7.129v38.883h11.729v6.48h-18.857V9.717z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B0B0B1",
  d: "M172.883,9.717h7.129V55.08h-7.129V9.717z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B0B0B1",
  d: "M191.545,22.224V55.08h-6.416V9.717h8.943l7.322,27.153V9.717h6.352V55.08h-7.323L191.545,22.224z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B0B0B1",
  d: "M219.991,28.834h9.785v6.48h-9.785v13.285h12.313v6.48h-19.44V9.717h19.44v6.48h-12.313V28.834z"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  enableBackground: "new    "
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 0.4,
  d: "M79.703,9.717h7.128V55.08h-7.128V9.717z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 0.4,
  d: "M107.114,41.925l4.86-32.208h9.915V55.08h-6.74V22.549l-4.925,32.531 h-6.74l-5.314-32.078V55.08h-6.221V9.717h9.915L107.114,41.925z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 0.4,
  d: "M134.199,28.834h9.785v6.48h-9.785v13.285h12.313v6.48h-19.441V9.717 h19.441v6.48h-12.313V28.834z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 0.4,
  d: "M150.916,9.717h7.129v38.883h11.729v6.48h-18.857V9.717z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 0.4,
  d: "M172.883,9.717h7.129V55.08h-7.129V9.717z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 0.4,
  d: "M191.545,22.224V55.08h-6.416V9.717h8.943l7.322,27.153V9.717h6.352 V55.08h-7.323L191.545,22.224z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 0.4,
  d: "M219.991,28.834h9.785v6.48h-9.785v13.285h12.313v6.48h-19.44V9.717 h19.44v6.48h-12.313V28.834z"
}));

function SvgArtimelineLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "238.648px",
    height: "66.68px",
    viewBox: "0 0 238.648 66.68",
    enableBackground: "new 0 0 238.648 66.68",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtimelineLogo);
export default __webpack_public_path__ + "static/media/ARTIMELINE-logo.ee5a38f5.svg";
export { ForwardRef as ReactComponent };